import React, { useEffect, useState } from "react";
import axios from "axios";
import ScrollAnimation from "react-animate-on-scroll";
import LargeHeroBanner from "components/large_hero_banner";

const Contact1 = ({ bgOverride }) => {
  const [submitting, setSubmitting] = useState(false);
  const [submitted, setSubmitted] = useState(false);
  const [errored, setErrored] = useState(false);

  const [firstName, setFirstName] = useState();
  const [lastName, setLastName] = useState();
  const [emailAddress, setEmailAddress] = useState();
  const [value, setValue] = useState();
  const [contactNumber, setContactNumber] = useState();
  const [partner, setPartner] = useState();
  // const [loanType, setLoanType] = useState('business loan');
  const [title, setTitle] = useState();

  const submit = (e) => {
    e && e.preventDefault();
    setErrored(false);
    setSubmitted(true);
    axios
      .post("https://prod-api.finstead.com.au/finsteadrs/site-contact-form/", {
        first_name: firstName,
        last_name: lastName,
        email_address: emailAddress,
        contact_number: contactNumber,
      })
      .then((response) => {
        setSubmitting(false);
        setSubmitted(true);
      })
      .catch(() => {
        setSubmitting(false);
        setErrored(true);
      });
  };

  return (
    <div>
      <div id="header-area-space" className="slider-area bg-light-primary" />
      <LargeHeroBanner bgImage={"/img/slider/slider1-1.jpg"}>
        <div className={"row w-100"}>
          <div className={"col-lg-6 col-xs-12"}>
            <div
              className={
                "calculation-content margin-b-30r md--space-b-70r mt-4"
              }
              style={{ color: "white" }}
            >
              <h2>
                <strong>Contact Us</strong>
              </h2>
              <h2>Your Insurance and Risk Specialists</h2>
              <br />
              <a
                href="tel:+611300906963"
                className="btn-fill color-light radius-4 btn-icon size-sm icon-right mt-2"
              >
                Call Us: 1300 906 963{" "}
              </a>
            </div>
          </div>
          <div className="col-lg-6 col-xs-12">
            <ScrollAnimation animateIn="fadeInRight">
              <div
                className="calculation-loan margin-b-30r mt-5"
                style={{
                  boxShadow: "2px 2px 0px 0px #424242",
                  border: "1px solid #e2e2e2",
                  maxWidth: "550px",
                  margin: "auto auto",
                  backgroundColor: "rgba(255,255,255,0.9)",
                  borderRadius: "15px",
                }}
              >
                <form id="loan-calculate-form" onSubmit={submit}>
                  <div>
                    <div className="w-100 text-center rounded">
                      <ScrollAnimation animateIn="fadeIn">
                        {errored ? (
                          <h3 className="text-dark">
                            Uh oh! There was an error.
                          </h3>
                        ) : submitted ? (
                          <h3 className="text-dark">Success!</h3>
                        ) : submitting ? (
                          <h3 className="text-dark">
                            Submitting your details...
                          </h3>
                        ) : (
                          <p
                            className="alert alert-secondary rounded text-center"
                            style={{ fontSize: "0.9em" }}
                          >
                            Please enter your details below
                          </p>
                        )}
                      </ScrollAnimation>
                    </div>

                    {submitting ? (
                      <div className="text-center w-100">Just a moment...</div>
                    ) : errored ? (
                      <div className="text-center">
                        <i
                          className="fa fa-times-circle"
                          style={{
                            color: "black",
                            fontSize: "25px",
                            marginBottom: "15px",
                          }}
                        ></i>
                        <p className="lead" style={{ color: "black" }}>
                          Something went wrong when submitting your referral,
                          please refresh the page and try again.
                        </p>
                      </div>
                    ) : submitted ? (
                      <div className="text-center">
                        <i
                          className="fa fa-check-circle"
                          style={{
                            color: "black",
                            fontSize: "25px",
                            marginBottom: "15px",
                          }}
                        ></i>
                        <p
                          className="lead text-center"
                          style={{ color: "black" }}
                        >
                          You have successfully submitted your details.
                        </p>
                        <p className="lead" style={{ color: "black" }}>
                          {title
                            ? `A Finstead broker dedicated to ${title} clients will be in touch with you shortly`
                            : "One of our brokers will contact you during the next business day"}
                        </p>
                      </div>
                    ) : (
                      <div className="w-100">
                        <div className="row">
                          <div className="col-md-6">
                            <div className="form-group">
                              <input
                                type="text"
                                className="form-control"
                                style={{
                                  padding: "7px 10px",
                                  height: "50px",
                                  color: "#D9973E",
                                  border: "1px solid #dedede",
                                  fontSize: "16px",
                                }}
                                placeholder="First Name"
                                required
                                value={firstName}
                                onChange={(e) => setFirstName(e.target.value)}
                                disabled={submitting}
                              />
                            </div>
                          </div>
                          <div className="col-md-6">
                            <div className="form-group">
                              <input
                                type="text"
                                className="form-control"
                                style={{
                                  padding: "7px 10px",
                                  height: "50px",
                                  color: "#D9973E",
                                  border: "1px solid #dedede",
                                  fontSize: "16px",
                                }}
                                placeholder="Last Name"
                                required
                                value={lastName}
                                onChange={(e) => setLastName(e.target.value)}
                                disabled={submitting}
                              />
                            </div>
                          </div>
                        </div>

                        <div className="form-group">
                          <input
                            type="text"
                            className="form-control"
                            style={{
                              padding: "7px 10px",
                              height: "50px",
                              color: "#D9973E",
                              border: "1px solid #dedede",
                              fontSize: "16px",
                            }}
                            placeholder="Mobile Phone"
                            required
                            value={contactNumber}
                            onChange={(e) => setContactNumber(e.target.value)}
                            disabled={submitting}
                          />
                        </div>
                        <div className="form-group">
                          <input
                            type="email"
                            className="form-control"
                            style={{
                              padding: "7px 10px",
                              height: "50px",
                              color: "#D9973E",
                              border: "1px solid #dedede",
                              fontSize: "16px",
                            }}
                            placeholder="Email Address"
                            required
                            value={emailAddress}
                            onChange={(e) => setEmailAddress(e.target.value)}
                            disabled={submitting}
                          />
                        </div>

                        <button
                          type="submit"
                          className="btn-ghost-hybrid color-dark w-100 mt-1 mb-5"
                          style={{ textAlign: "center" }}
                          disabled={submitting}
                        >
                          Submit
                        </button>
                      </div>
                    )}
                    <div
                      className="text-center tc-text w-100 text-center"
                      style={{ fontSize: "0.7em" }}
                    >
                      <p className="text-small text-dark">
                        By submitting you agree to the{" "}
                        <a href="/privacy">
                          Finstead Risk Solutions Privacy Policy
                        </a>
                      </p>
                    </div>
                  </div>
                </form>
              </div>
            </ScrollAnimation>
          </div>
        </div>
      </LargeHeroBanner>
    </div>
  );
};

export default Contact1;
